import { JSON_CONTENT_TYPE, TOKEN_NAME } from '../../constant/constants';
import { IApiParams } from '../../interface/IApiParams';
import { getApiArshin } from '../getApiArshin';

export const apiGetArshin = async (id: string) => {
  const params: IApiParams = {
    url: `/info/getArshin.php?id=${id}`,
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      Token: localStorage.getItem(TOKEN_NAME),
    },
  };
  return getApiArshin(params, 'GET');
};
